import { ref, nextTick } from 'vue'

// Global toast state
const toasts = ref([])
let toastId = 0

export const useToast = () => {
  const addToast = (options) => {
    const id = ++toastId
    const toast = {
      id,
      type: options.type || 'info',
      title: options.title || '',
      message: options.message || '',
      duration: options.duration || 5000,
      persistent: options.persistent || false
    }
    
    toasts.value.push(toast)
    return id
  }

  const removeToast = async (id) => {
    // Use nextTick to ensure DOM operations are complete
    await nextTick()
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clearAllToasts = () => {
    toasts.value = []
  }

  // Convenience methods
  const showSuccess = (title, message = '', options = {}) => {
    return addToast({
      type: 'success',
      title,
      message,
      ...options
    })
  }

  const showError = (title, message = '', options = {}) => {
    return addToast({
      type: 'error',
      title,
      message,
      ...options
    })
  }

  const showWarning = (title, message = '', options = {}) => {
    return addToast({
      type: 'warning',
      title,
      message,
      ...options
    })
  }

  const showInfo = (title, message = '', options = {}) => {
    return addToast({
      type: 'info',
      title,
      message,
      ...options
    })
  }

  return {
    toasts,
    addToast,
    removeToast,
    clearAllToasts,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
} 